import Vue from 'vue';

Vue.mixin({
  computed: {
    activeTab: {
      get() {
        return this.$store.state.activeTab
      },
      set(tab) {
        this.$store.commit('setter', {activeTab: tab})
      }
    },
    tabs: {
      get() {
        return this.$store.state.tabs
      },
      set(tabs) {
        this.$store.commit('setter', {tabs: tabs})
      }
    },
    isShowDocument: {
      get() {
        return this.$store.state.isShowDocument
      },
      set(value) {
        this.$store.commit('setter', {isShowDocument: value})
      }
    },
    Lead() {
      return this.$store.state.leadData;
    },
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;

      this.tabs = this.tabs.map((item) => {
        item.isActive = item.code === tab;
        return item;
      });
    },
    updateDocuments() {
      this.isShowDocument = false;
      if (this.Lead.info) {
        console.log(this.Lead.info);
        this.$store.dispatch('getDocuments', {
          action: 'listdocumentsbylead',
          login: this.Lead.info.login,
        });
      }
    },
    getPrograms() {
      this.$store.dispatch('getPrograms', {
        action: 'list',
        limit: 10,
        offset: 0,
        login: this.Lead.info.login
      });
    },
    groupBy(data) {
      if (data && Array.isArray(data)) {
        return this.lodash.groupBy(data, function (item) {
          return item.action_type + ',' + item.user_name + ',' + item["date&time"];
        });
      }

      return {};
    },
  }
});
